import { LogFetchError } from 'app/shared_components/helpers'
import { apiBaseUrl } from 'app/shared_components/shared_base_url'
import { api } from 'app/utils/api/helpers'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'

export const getTeamActivities = (teamGUID, options) => {
  const {
    startDate = '',
    endDate = '',
    manager = [],
    sort_dir = '',
    sort = '',
    propertyGUID = '',
    cursor = '',
    limit = 10,
    teams = [],
    pods = [],
  } = options

  const url = `${apiBaseUrl}sm/teams/${teamGUID}/activity?startTime=${startDate}&endTime=${endDate}&sort_dir=${sort_dir}&sort=${sort}&limit=${limit}&cursor=${cursor}&property=${propertyGUID}`
  let managerParams = new URLSearchParams()

  manager.forEach((managerGUID) => managerParams.append('manager', managerGUID))
  teams.forEach((teamId) => managerParams.append('team', teamId))
  pods.forEach((podId) => managerParams.append('pods', podId))

  return fetch(url + `&${managerParams}`, {
    credentials: 'include',
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }).append(
      'Content-Type',
      'text',
    ),
  })
    .catch((error) => LogFetchError(error))
    .then((res) => {
      return res.ok
        ? res.json()
        : Promise.reject({ statusCode: res.status, responseText: res.text() })
    })
    .then((activities) => {
      return { ok: true, activities }
    })
    .catch((error) => {
      return {
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
      }
    })
}

export const getAdvanceTeamActivities = (teamGUID, options) => {
  const {
    startDate = '',
    endDate = '',
    manager = [],
    sort_dir = '',
    sort = '',
    propertyGUID = '',
    cursor = '',
    limit = 10,
    teams = [],
    pods = [],
    startOfPriorMonth,
    endOfPriorMonth,
    startOfPriorYearCurrentMonth,
    endOfPriorYearCurrentMonth,
  } = options

  const url = `${apiBaseUrl}sm/teams/${teamGUID}/advancedactivity`
  let searchParams = new URLSearchParams({
    startTime: startDate,
    endTime: endDate,
    sort_dir: sort_dir,
    sort: sort,
    limit: String(limit),
    cursor: cursor,
    property: propertyGUID,
    startOfPriorMonth: startOfPriorMonth,
    endOfPriorMonth: endOfPriorMonth,
    startOfPriorYearCurrentMonth: startOfPriorYearCurrentMonth,
    endOfPriorYearCurrentMonth: endOfPriorYearCurrentMonth,
  })

  manager.forEach((managerGUID) => searchParams.append('manager', managerGUID))
  teams.forEach((teamId) => searchParams.append('team', teamId))
  pods.forEach((podId) => searchParams.append('pods', podId))

  return fetch(url + `?${searchParams}`, {
    credentials: 'include',
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }).append(
      'Content-Type',
      'text',
    ),
  })
    .catch((error) => LogFetchError(error))
    .then((res) => {
      return res.ok
        ? res.json()
        : Promise.reject({ statusCode: res.status, responseText: res.text() })
    })
    .then((advanceActivities) => {
      return { ok: true, advanceActivities }
    })
    .catch((error) => {
      return {
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
      }
    })
}

export const getPropertiesActivitiesReport = (teamGUID, options) => {
  return api.get(`/sm/teams/${teamGUID}/propertiesactivities`, {
    params: { ...options },
  })
}
